/**
 * Work that is built but held back from users. Flip a flag to `true` to bring it back; nothing
 * else needs restoring.
 */

/**
 * Vessel invitation codes: "Invite with code" and the pending codes on the vessel page, and the
 * "join your crew" path of the crew onboarding, with the `/onboarding?code=` share link that
 * leads to it.
 */
export const INVITE_CODES_ENABLED: boolean = true;

/**
 * The CV in the crew onboarding: its Autofill / Enter manually tabs and the upload. Nothing reads a
 * CV into the profile yet (there is no CV type in the extract service), so the step asks only for
 * the fields, and the CV is added later on the profile page.
 */
export const CV_AUTOFILL_ENABLED: boolean = false;
